module.exports = __webpack_public_path__ + "static/media/30-7.9798fa5e.mp3";